module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'security.fork'
      }
    }
  }, [_vm._v("Fork rewrite")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'security.chain'
      }
    }
  }, [_vm._v("Chain rewrite")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0, false, false)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("The idea for these charts originate from Pieter Wuille. \n        See "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://bitcoin.sipa.be/index.html"
    }
  }, [_vm._v("bitcoin.sipa.be")]), _vm._v(" \"Proof of Work Equivalent Days\".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4abe3d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/security.vue
// module id = 561
// module chunks = 1